import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavMenuComponent } from './nav-menu.component';
import { LoginMenuComponent } from './login-menu/login-menu.component';
import { LoaderModule } from 'src/app/shared/loader/loader.module';
import { ResourcesService } from 'src/app/shared/services/resources.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoggingService } from 'src/app/shared/services/logging.service';
import { NavMenuService } from './service/nav-menu.service';


@NgModule({
  declarations: [NavMenuComponent, LoginMenuComponent],
  imports: [CommonModule, 
            RouterModule,
            LoaderModule,
            ReactiveFormsModule,
            FormsModule, ],
  providers: [NavMenuService,
              ResourcesService,
              LoggingService],
  exports: [NavMenuComponent, LoginMenuComponent],
})
export class NavMenuModule {}
